// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__1jVdJ","primary":"styles_primary__tNeWA","secondary":"styles_secondary__3WxU2"};